import Vue from 'vue';

export const loadingRefreshToken = Vue.observable({ isLoading: false });

export const observableMutationsRefreshToken = {
  setLoadingRefreshToken(value) {
    loadingRefreshToken.isLoading = value;
  },
};
